{
  "titles": {
    "login": "Aanmelden"
  },
  "fields": {
    "labels": {
    "email": "E-mail",
    "password": "Wachtwoord"
  },
    "placeholders": {
      "email": "Vul je email in"
    }
  },
  "errors": {
    "messages": {
      "403NoRole": "Je account is geen partner account. Log in met een partneraccount of, als je het idee hebt dat dit een fout is, neem dan contact op met de DebitRoom.",
      "403NoPartner": "Helaas is het inloggen niet gelukt. Neem voor meer informatie contact op met vragen\\@debitroom.com."
    }
  },
  "actions": {
    "login": "Inloggen",
    "logout": "Uitloggen"
  }
}
